module.exports = __webpack_public_path__ + "img/ep-logo-color.159bdf55.png";